import {
  Avatar,
  Box,
  Button,
  IconButton,
  Modal,
  Typography
} from "@mui/material";

import { Lock } from "@mui/icons-material";

import OtpInput from "../mui-components/OtpInput";
import Timer from "../mui-components/Timer";

export default function VerifyMobileModal({
  verifyFlag,
  style,
  OTP,
  setOTP,
  OTPMsg,
  setOTPMsg,
  containsAtLeastOneNumber,
  aguserStore,
  AguserApi,
  setVerifyFlag
}) {

  return (
    <Modal
      open={verifyFlag}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{ ...style, width: '27%', marginTop: '-50px' }}>
        <IconButton
          sx={{
            position: 'absolute',
            top: '-30px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1
          }}
        >
          <Avatar style={{ backgroundColor: '#266ed4' }}>
            <Lock fontSize="large" sx={{ color: 'white' }} />
          </Avatar>
        </IconButton>

        <Box
          sx={{
            display: "flex",
            flexDirection: 'column',
            gap: 2,
            paddingTop: "32px",
            paddingBottom: "10px"
          }}
        >
          <Box
            sx={{
              textAlign: 'left',
              margin: '0 auto',
              maxWidth: '350px'
            }}
          >
            <Typography
              sx={{
                fontWeight: 'bold',
                fontFamily: 'Figtree',
                color: 'black',
                fontSize: '1.4rem',
                mb: 1
              }}
            >
              To Verify Your Mobile Number
            </Typography>

            <Typography
              sx={{
                fontWeight: 'normal',
                fontFamily: 'Figtree',
                color: 'black',
                fontSize: '1rem',
                mb: 1
              }}
            >
              OTP has been sent to your phone <br />
              <span style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>
                {aguserStore.aguserRec.phonePrefix}{" "}
                {aguserStore.aguserRec.phone}
              </span>{" "}
              via SMS and WhatsApp
            </Typography>

            <OtpInput
              length={6}
              callback={(e) => {
                setOTP(e);
              }}
              errorsmsg={OTPMsg !== 'verified' && OTPMsg}
            />

            {!containsAtLeastOneNumber(OTPMsg) && (
              <div
                className='mb-4 is-flex is-justify-content-space-between is-align-items-center'
                style={{ fontSize: '12px' }}
              >
                <p>Didn't get it?</p>

                <Timer
                  seconds={30}
                  minutes={0}
                  resend={async () => {
                    await AguserApi.GetMobileOTP({
                      userRec: aguserStore.aguserRec
                    });
                  }}
                />
              </div>
            )}

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-around',
                mt: 2
              }}
            >
              <Button
                variant="contained"
                sx={{
                  width: '48%',
                  backgroundColor: 'white',
                  mr: 1,
                  padding: '8.5px 0',
                  color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                  '&:hover': {
                    backgroundColor: '#e0e0e0'
                  },
                  '&.btn_color': {
                    backgroundColor: 'white'
                  }
                }}
                onClick={() => {
                  setVerifyFlag(false);
                  setOTPMsg("");
                }}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                className='btn_color'
                sx={{
                  width: '48%',
                  ml: 1,
                  padding: '8.5px 0'
                }}
                onClick={async () => {
                  if (OTP.length == 6) {
                    await AguserApi.VerifyMobileOTP(
                      {
                        email: aguserStore.aguserRec.email,
                        otp: OTP,
                        phone: aguserStore.aguserRec.phone,
                        phonePrefix:
                          aguserStore.aguserRec.phonePrefix
                      },
                      (user) => {
                        if (user.success) {
                          setVerifyFlag(false);
                          setOTPMsg(user.msg);

                          if (
                            aguserStore.aguserRec.phone &&
                            aguserStore.aguserRec.phonePrefix === '+91'
                          ) {
                            aguserStore.aguserRec.mobileVerified =
                              !aguserStore.aguserRec.mobileVerified;
                          }
                        } else {
                          setOTPMsg(user.msg);
                        }
                      }
                    );
                  } else {
                    setOTPMsg('Please enter the valid OTP');
                  }
                }}
                disabled={containsAtLeastOneNumber(OTPMsg)}
              >
                Submit
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}